export default "__VITE_ASSET__f0c6e8d2__"